'use strict';
!function(jQ$) {
  /**
   * @return {?}
   */
  function gotoNewOfflinePage() {
    return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency || window.show_auto_currency;
  }
  /**
   * @param {?} t
   * @return {undefined}
   */
  function t(t) {
    this.headerSearch = jQ$(t);
    this.headerSearchForm = this.headerSearch.find(".header-search__form");
    this.headerInput = this.headerSearch.find('.header-search__input');
//     console.log('Header input', this.headerInput);

    this.headerSearchResults = this.headerSearch.find(".header-search__results-wrapper");
    this.searchResultsTemplate = Template7.compile($("#search-results-template").html());
    this.PopularProducts = this.headerSearch.find(".header-search__product");
    /** @type {string} */
    this.searchMode = "product";
    this.searchTrending = $(".quickSearchResultsWrap .header-search__trending .item-tag");
    this.trending = $(".header-search__trending");
    this.searchWrapper = this.headerSearch.find(".quickSearchResultsWrap");
    jQ$(this.headerInput).click(function(event) {
      event.stopPropagation();
      jQ$(this.searchWrapper).show();
      jQ$(".highlight").on("click", function(event) {
        event.preventDefault();
        var h = $(event.target).attr("href");
        window.location.href = h;
      });
    });
    jQ$(document).mouseup(function(e) {
      var toggle_object = jQ$(".search-form");
      if (!(toggle_object.is(e.target) || 0 !== toggle_object.has(e.target).length)) {
        toggle_object.find(".quickSearchResultsWrap").hide();
      }
    });
    this.headerInput.on("focusin", jQ$.proxy(this._focusin, this));
    this.headerInput.on("keyup", jQ$.proxy(this._initSearch, this));
    
//     $('#navSearch').on('keyup', '#searcher', $.proxy(this._initSearch, this));
  }
  /**
   * @param {!Event} event
   * @return {undefined}
   */
  t.prototype._initSearch = function(event) {
    var $iFrame = jQ$(event.target);
    if (13 != (event.keyCode ? event.keyCode : event.which)) {
      clearTimeout($iFrame.data("timeout"));
      $iFrame.data("timeout", setTimeout(jQ$.proxy(this._doSearch, this), 250));
    }
  };
  /**
   * @param {?} candidateFilesPromise
   * @return {?}
   */
  t.prototype._doSearch = function(candidateFilesPromise) {
    if ("" === this.headerInput.val().trim()) {
      return this.headerSearchResults.empty(), this.searchTrending.show(), this.PopularProducts.show(), this.searchWrapper.show(), void this.trending.show();
    }
    this.headerSearchResults.html(this.searchResultsTemplate({
      is_loading : true
    }));
    if (this.headerInput.val().length > 2) {
      this.searchWrapper.hide();
      this._doCompleteSearch();
    } else {
      this.headerSearchResults.html(this.searchResultsTemplate({
        is_show : false
      }));
      this.searchTrending.show();
      this.PopularProducts.show();
      this.searchWrapper.show();
    }
    if ("none" == this.searchTrending.css("display")) {
      this.trending.hide();
    } else {
      this.trending.show();
    }
  };
  /**
   * @param {?} canCreateDiscussions
   * @return {undefined}
   */
  t.prototype._doCompleteSearch = function(canCreateDiscussions) {
    var self = this;
    jQ$.ajax({
      method : "GET",
      url : window.router + "/search?view=json",
      dataType : "json",
      data : {
        q : this.headerInput.val() + "*",
        type : this.searchMode
      }
    }).then(function(res) {
      self.headerSearchResults.html(self.searchResultsTemplate({
        is_show : true,
        is_loading : false,
        results : res.results,
        has_results : res.results.length > 0,
        results_count : res.results_count,
        results_label : res.results_label,
        results_url : res.url + "&type=" + self.searchMode
      }));
      self.PopularProducts.hide();
      var sceneUid = self.headerInput.val().toLowerCase();
      if (gotoNewOfflinePage()) {
        Currency.convertAll(window.shop_currency, jQ$("#currencies .active").attr("data-currency"), "span.money", "money_format");
      }
      if (res && res.length) {
        self.searchTrending.filter(function(canCreateDiscussions) {
          jQ$(this).toggle(jQ$(this).find(".highlight span").text().toLowerCase().indexOf(sceneUid) > -1);
        });
        self.trending.show();
      } else {
        self.trending.hide();
      }
      self.searchWrapper.show();
    });
  };
  /**
   * @param {boolean} options
   * @return {?}
   */
  jQ$.fn.Search = function(options) {
    /** @type {boolean} */
    var e = false;
    /** @type {!Arguments} */
    var methodArgs = arguments;
    return "string" == typeof options && (e = options), this.each(function() {
      var originalEvent = jQ$.data(this, "plugin_Search");
      if (originalEvent || e) {
        if (e) {
          callMethod(originalEvent, e, Array.prototype.slice.call(methodArgs, 1));
        }
      } else {
        jQ$.data(this, "plugin_Search", new t(this, options));
      }
    });
  };
  
  jQ$("[data-search-form]").Search();
  
}(window.jQuery);